module.exports = __webpack_public_path__ + "static/media/scale.2df56e88.png";